<template>
    <div id="tab2" class="content easein comics" :class="{ 'easein-active': opacitys }">
        <div class="split-title easein" :class="{ 'easein-active': opacitys }">
            <div class="line"></div>
            {{ desc.motion_comic.configName }}
            <div class="line"></div>
        </div>
        <div class="split-desc easein" :class="{ 'easein-active': opacitys }">
            {{ desc.motion_comic.configContent }}
        </div>
        <div class="comics-container">
            <div
                class="comics-content"
                @mouseenter="onMouseEnterComics"
                @mouseleave="onMouseLeaveComics"
                v-if="comics.length > 0"
            >
                <div class="comics-tabs" :class="{ 'comics-tabs-active': comicsMaskShow }">
                    <div
                        class="comics-tabs-item"
                        :class="{ 'comics-tabs-item-active': comicsTabIndex == index }"
                        v-for="(item, index) in comicsTabs"
                        :key="index"
                        @click="onClickComicsTab(index)"
                    >
                        {{ item }}
                    </div>
                </div>
                <div
                    class="comics-tabs-item-postion"
                    :class="{ 'comics-tabs-item-postion-active': comicsMaskShow }"
                    :style="`transform: translateX(${position})`"
                >
                    {{ comicsTabTitle }}
                </div>
                <swiper ref="comicsSwiper" class="swiper-no-swiping" :options="comicsSwiperOptions">
                    <swiper-slide
                        class="comics-swiper-slide"
                        v-for="(items, index) in comics[comicsTabIndex]"
                        :key="index"
                    >
                        <el-image :src="items.motionComicImg" />
                    </swiper-slide>
                </swiper>
                <swiper class="gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                    <swiper-slide v-for="(items, index) in comics[comicsTabIndex]" :key="index">
                        <div class="gallery-thumbs-border">
                            <img :src="items.motionComicImg" />
                        </div>
                        <!-- <div
                            :class="{ 'gallery-thumbs-maske': comicsIndex != index }"
                            style="font-size: 12px; color: white"
                        >
                        </div> -->
                    </swiper-slide>
                </swiper>
                <!-- <Column :comics="comics[comicsTabIndex]" :comicsIndex="comicsIndex" @update="updateComic" /> -->
                <div class="comics-mask" :class="{ 'comics-mask-active': comicsMaskShow }" v-if="comics.length > 0">
                    <div class="comics-mask-title">
                        {{ comics[comicsTabIndex][comicsIndex].motionComicTitle }}
                    </div>
                    <div class="comics-mask-desc" v-html="comics[comicsTabIndex][comicsIndex].synopsis" />
                    <a :href="comics[comicsTabIndex][comicsIndex].audioUrl" target="_blank">
                        <div class="comics-mask-button">
                            <svg-icon iconClass="play" />
                            立即播放
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { findMotionComicList } from '@/api/home'
// import Column from './cloumn.vue'

export default {
    name: 'Comics',
    components: {
        // Column,
    },
    props: {
        desc: {
            type: Object,
            default: () => {},
        },
        opacitys: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        const vm = this
        return {
            comicsMaskShow: false,
            comicsTabIndex: 0,
            comicsIndex: 0,
            comicsTabTitle: '漫画PV',
            comicsTabs: [],
            comics: [],
            position: 0,
            comicsSwiperOptions: {
                loop: true,
                loopedSlides: 5,
                on: {
                    slideChangeTransitionStart: function () {
                        // vm.comicsIndex = this.realIndex
                    },
                },
            },
            swiperOptionThumbs: {
                loop: true,
                loopedSlides: 5, // looped slides should be the same
                spaceBetween: 20,
                centeredSlides: true,
                slidesPerView: 5,
                touchRatio: 0.2,
                slideToClickedSlide: true,
                direction: 'vertical',
                // autoplay: {
                //     delay: 3000,
                //     stopOnLastSlide: false,
                //     disableOnInteraction: false,
                //     pauseOnMouseEnter: true,
                // },
                on: {
                    tap: function () {
                        // vm.comicsIndex = this.realIndex
                        // vm.$forceUpdate()
                        // console.log(vm.comicsIndex)
                    },
                    slideChangeTransitionEnd: function () {
                        vm.comicsIndex = this.realIndex
                    },
                },
            },
            style: {
                transform: `translateY(0)`,
            },
            timer: null,
        }
    },
    computed: {
        comicsSwiper() {
            return this.$refs.comicsSwiper.$swiper
        },
    },
    created() {
        this.findMotionComicList()
    },
    mounted() {
        this.timer = setInterval(() => {
            if (this.$refs.comicsSwiper && this.$refs.swiperThumbs) {
                const swiperTop = this.$refs.comicsSwiper.$swiper

                const swiperThumbs = this.$refs.swiperThumbs.$swiper

                swiperTop.controller.control = swiperThumbs

                swiperThumbs.controller.control = swiperTop

                clearInterval(this.timer)
            }
        }, 500)
    },
    methods: {
        mouseenter(index) {
            console.log(index)
        },
        onClickComicsTab(index) {
            this.$refs?.comicsSwiper?.$swiper.update()
            this.$refs.comicsSwiper.$swiper.slideTo(0)
            this.comicsTabIndex = index
            this.comicsIndex = 0
            this.comicsTabTitle = this.comicsTabs[index]
            const query = document.querySelector('.comics-tabs')
            const width = query.clientWidth / this.comicsTabs.length
            this.position = `${index * width}px`
        },
        onClickThumbs(index) {
            console.log(index)
            console.log('========')
        },
        updateComic(index) {
            this.$refs.comicsSwiper.$swiper.autoplay.stop()
            this.$refs.comicsSwiper.$swiper.slideTo(index + 1)
            this.$refs.comicsSwiper.$swiper.autoplay.start()
            this.comicsIndex = index
        },
        onMouseEnterComics() {
            this.comicsMaskShow = true
        },
        onMouseLeaveComics() {
            this.comicsMaskShow = false
        },
        async findMotionComicList() {
            const params = {
                pageNo: 1,
                pageSize: 100,
            }

            const res = await findMotionComicList(params)

            this.comicsTabs = res.map((items) => items.typeName)

            this.comics = res.map((items) => items.pageComicList.rows)

            const [title] = this.comicsTabs

            if (title) {
                this.comicsTabTitle = title
            }
        },
    },
}
</script>

<style lang="scss">
.comics {
    .comics-container {
        width: 1600px;
        // height: 1400px;
        margin: 0 auto;
        margin-top: 60px;
        // position: relative;
        .comics-content {
            width: 100%;
            height: 1000px;
            position: relative;
            .comics-tabs {
                width: 100%;
                height: 80px;
                display: flex;
                position: absolute;
                z-index: 11011;
                top: 0;
                opacity: 0;
                transition: all 0.5s ease-in-out;
                .comics-tabs-item {
                    color: #333333;
                    font-size: 18px;
                    font-weight: 500;
                    width: 400px;
                    height: 100%;
                    text-align: center;
                    line-height: 80px;
                    cursor: pointer;
                    background: rgba($color: #ffffff, $alpha: 1);
                }
                .comics-tabs-item-active {
                    color: #ffffff;
                    transition: all 0.5s;
                }
            }
            .comics-tabs-active {
                opacity: 0.9;
                transition: all 0.5s ease-in-out;
            }

            .comics-tabs-item-postion {
                background: rgba($color: #f1592a, $alpha: 1);
                color: #ffffff;
                font-size: 18px;
                font-weight: 500;
                text-align: center;
                line-height: 80px;
                width: 400px;
                height: 80px;
                position: absolute;
                top: 0;
                z-index: 11011;
                opacity: 0;
                transition: all 0.5s ease-in-out;
            }
            .comics-tabs-item-postion-active {
                opacity: 1;
                transition: all 0.5s ease-in-out;
            }

            .gallery-thumbs {
                position: absolute;
                top: 0;
                right: 20px;
                width: 300px;
                height: 1000px;
                overflow: hidden;
                padding: 20px 0;
                box-sizing: border-box;
                .swiper-slide {
                    width: 300px;
                    height: 160px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: flex-end;
                    position: relative;
                    cursor: pointer;
                    .gallery-thumbs-border {
                        width: 260px;
                        height: 100%;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    // .gallery-thumbs-maske {
                    //     width: 260px;
                    //     height: 100%;
                    //     position: absolute;
                    //     top: 0;
                    //     right: 0;
                    //     box-sizing: border-box;
                    //     display: flex;
                    //     justify-content: flex-end;
                    //     background: rgba($color: #000000, $alpha: 0.6);
                    //     z-index: 11011;
                    // }
                }
                .swiper-slide-active .gallery-thumbs-border {
                    border: 6px solid #f1592a;
                    box-sizing: border-box;
                }
                .swiper-slide::after {
                    content: '';
                    width: 260px;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    right: 0;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: flex-end;
                    background: rgba($color: #000000, $alpha: 0.6);
                    z-index: 11011;
                }
                .swiper-slide-active::after {
                    background: transparent;
                }
                .swiper-slide-active::before {
                    content: '';
                    width: 0;
                    height: 0;
                    position: absolute;
                    left: 8px;
                    border: 16px solid;
                    border-color: transparent;
                    border-right-color: #f1592a;
                    z-index: 11011;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .el-image {
                width: 100%;
                height: 1000px;
                object-fit: cover;
                z-index: 1;
            }
            .comics-mask {
                width: 500px;
                // height: 248px;
                padding: 20px 50px;
                box-sizing: border-box;
                color: #ffffff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: rgba($color: #000000, $alpha: 0.6);
                opacity: 0;
                transition: all 0.5s ease;
                .comics-mask-title {
                    font-size: 20px;
                    font-weight: bold;
                }
                .comics-mask-desc {
                    font-size: 14px;
                    font-weight: 500;
                    margin-top: 25px;
                    text-align: justify;
                    text-align-last: left;
                }
                .comics-mask-button {
                    font-size: 16px;
                    font-weight: 500;
                    border: 1px solid #fff;
                    width: 200px;
                    height: 38px;
                    text-align: center;
                    line-height: 38px;
                    margin: 0 auto;
                    margin-top: 14px;
                    cursor: pointer;
                }
            }
            .comics-mask-active {
                opacity: 1;
                transition: all 0.5s ease;
                z-index: 11011;
            }
        }
    }
}
</style>
